export class Breadcrumb {
  name: string;
  path: string;

  constructor(name: string, path: string) {
    this.name = name;
    this.path = path;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/_base/breadcrumb.model.ts